module.exports = __webpack_public_path__ + "static/media/result.96566b45.png";